import { AIAgent } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const aiAgentTag = "AIAgent";

export interface AIAgentUpdatePayload {
  company_scope: string;
  chosen_llm: string;
}

const aiAgentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAIAgent: builder.query<AIAgent | null, void>({
      query: () => "/ai-agent",
      transformResponse: (response: { data: AIAgent | null }) => response.data,
      providesTags: [aiAgentTag],
    }),
    updateAIAgent: builder.mutation<{ data: AIAgent }, AIAgentUpdatePayload>({
      query: (data) => ({
        url: "/ai-agent",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [aiAgentTag, "CompanyInfo"],
    }),
  }),
});

export const {
  useGetAIAgentQuery,
  useUpdateAIAgentMutation,
} = aiAgentApi;
